export const OPEN_GLOBAL_DIALOG = 'OPEN_GLOBAL_DIALOG';
export const CLOSE_GLOBAL_DIALOG = 'CLOSE_GLOBAL_DIALOG';
export const SET_GLOBAL_LOADER = 'SET_GLOBAL_LOADER';
export const OPEN_GLOBAL_MODAL = 'OPEN_GLOBAL_MODAL';
export const CLOSE_GLOBAL_MODAL = 'CLOSE_GLOBAL_MODAL';
